<template>
    <div
        class="kgr-checkbox ui-droppable"
        :class="{ 'kgr-checkbox--inline': inline, 'is-checked': state, 'readonly': readonly, 'click-area-minimized': clickAreaMinimized }"
        @click="handleWrapperClick"
    >
        <span
            class="kgr-checkbox__control"
            @click="handleControlClick"
        ></span>
        <span
            v-if="label !== null"
            class="kgr-checkbox__label"
            :class="{ 'kgr-text--italic': readonly, 'option-inactive': inactive }"
        >{{ label }}</span>
        <kgr-icon-info
            v-if="info"
            accent
            :title="info"
            class="icon-info-position"
            @click.stop
        />
        <div
            v-if="hint"
            class="kgr-inputGroup__text"
        >
            {{ hint }}
        </div>
    </div>
</template>

<script>
import IconInfo from '../../icon/IconInfo.vue';

export default {
    compatConfig: { MODE: 3 },

    components: {
        'kgr-icon-info': IconInfo,
    },

    props: {
        modelValue: {
            type: Boolean,
            required: false,
            default: null,
        },
        checked: {
            type: Boolean,
            required: false,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        info: {
            type: String,
            required: false,
            default: null,
        },
        hint: {
            type: String,
            required: false,
            default: null,
        },
        inactive: {
            type: Boolean,
            required: false,
            default: false,
        },
        clickAreaMinimized: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    emits: ['change', 'update:model-value'],

    data() {
        return {
            state: this.modelValue !== null ? this.modelValue : (this.checked !== undefined ? this.checked : false),
        };
    },

    watch: {
        checked(newVal) {
            if (newVal !== this.state) {
                this.state = newVal;
            }
        },
        modelValue(newVal) {
            if (newVal !== this.state) {
                this.state = newVal;
            }
        },
    },

    mounted() {
        if (this.modelValue === null && this.checked !== undefined) {
            this.$emit('update:model-value', this.checked);
        }
    },

    methods: {
        change() {
            if (this.readonly) {
                return;
            }
            this.state = !this.state;
            this.$emit('update:model-value', this.state);
            // legacy support
            this.$emit('change', this.state);
        },
        handleWrapperClick() {
            if (!this.clickAreaMinimized) {
                this.change();
            }
        },
        handleControlClick() {
            if (this.clickAreaMinimized) {
                this.change();
            }
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .readonly {
    & > .kgr-checkbox__label {
        cursor: not-allowed !important;
    }

    & span {
        opacity: 0.6;
    }
}
.icon-info-position {
    vertical-align: middle;
    pointer-events: auto;
}
.option-inactive {
    opacity: 0.3;
}
.kgr-checkbox.readonly {
    cursor: not-allowed;
}
.kgr-checkbox.click-area-minimized {
    cursor: default;
}
.kgr-checkbox.click-area-minimized .kgr-checkbox__control {
    cursor: pointer;
}
</style>
